export default "__VITE_ASSET__Dwy9a1Qx__"